<template>
    <div class="content">
        <h2>采样记录</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            
        </el-form>
    </div>
</template>

<script>
export default {
    name: "Layout",
    props:['code'],
    data() {
        return {
            loading:false,
            form:{},
            rules:{}
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        this.getList()
    },
    methods: {
        async getList(){
            
        },
        submit(){
            let that = this
            this.$confirm("您是否确定保存当前页面数据并生成文书?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                that.$emit('handleBack',1)
            })
        },
        getWh(){},
        getNr(){}
    }
}
</script>


<style scoped>
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>